import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CycleTimeMeasuringView } from "src/components/views/spc/controlChart/dataInput/CycleTimeMeasuringView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/cycleTimeMeasurement")({
	staticData: { title: i18n.t("cycle_time_measurement"), legacyViewKey: "cycleTimeMeasurementView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CycleTimeMeasuringView />;
}
